export const CLI_KIT_VERSION = '3.49.1'
